import React, { useEffect } from "react";
import { useGetAllApi } from "rk-react-component";
import { TableUser } from "../../../containers/tables/table-user/table-user";
import { PageIndexContainer } from "../../../containers/pages/page-index-container/page-index-container";
import { FormFilterUser } from "../../../containers/form-filter/form-filter-user/form-filter-user";
import { api } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { TableProject } from "../../../containers/tables/table-project/table-project";
import { FormFilterProject } from "../../../containers/form-filter/form-filter-project/form-filter-project";

export const ProjectIndexPage = () => {
    const navigate = useNavigate();
    const { dataList, loading, fetchDataList, pagination, filter, remove } = useGetAllApi<
        any,
        any
    >({
        url: "/projects",
        api,
        initialRequest: false,
        filterKey: "projectIndexPage"
    });
    useEffect(() => {
        fetchDataList({ per_page: 10, page: 1, ...filter });
    }, []);
    return (
        <PageIndexContainer
            title={"Projetos"}
            btnTitle={"Novo Projeto"}
            url={"/projects"}
            FormFilterComponent={
                <FormFilterProject onFinish={fetchDataList} initialValues={filter} />
            }
            TableComponent={() => (
                <TableProject
                    onDelete={remove}
                    filter={filter}
                    dataSource={dataList}
                    loading={loading}
                    loadData={fetchDataList}
                    pagination={pagination}
                    onEdit={(record) => navigate("/projects/" + record?.id)}
                />
            )}
        />
    );
};
